export default __webpack_public_path__ + "static/media/Claymore of the Crowned Serpent.13998192.jpg";